export const stringToDate = (dateString: string) => {
  const time = Date.parse(dateString)
  const date = new Date(time)
  return date
}
